import store from "../../store";
import { computed } from "vue";
import { empty } from "../../../helpers";
import { i18n } from "../../../i18n";

export default function useCustom() {
    const defaultImageUrl = null;
    const {
        t
    } = i18n.global
    const defaultAccountName = t("Account name")
    const defaultDescription = t("Description")
    const defaultLike = '_____'
    const defaultOthers = '_____'

    // computed
    const accountName = computed(() => getComputedAttribute(defaultAccountName, 'accountName'))

    const description = computed(() => getComputedAttribute(defaultDescription, 'description'))

    const like = computed(() => getComputedAttribute(defaultLike, 'like'))

    const others = computed(() => getComputedAttribute(defaultOthers, 'others'))

    const profileImageUrl = computed(() => getImage())

    function getComputedAttribute(defaultText, attribute) {
        const name = store.getters['product/getProduct'].attributes[attribute]

        return empty(name) ? defaultText : name
    }

    function getImage() {
        const cropperImage = store.getters['instaCropper/getFile']
        const originalImage = store.getters['instaUploader/getFiles']

        if (cropperImage) {
            return cropperImage
        } else if (originalImage) {
            return originalImage
        }

        return defaultImageUrl
    }

    return {
        accountName,
        description,
        like,
        others,
        defaultAccountName,
        defaultDescription,
        defaultLike,
        defaultOthers,
        profileImageUrl
    }
}
